import { onInitService } from "./init-service";

export { useHostPage } from "./hooks/use-host-page";
export {
  useEmbedPage,
  EMBED_CLOSE_MSG,
  EMBED_SELECT_MSG,
  EMBED_READY_MSG
} from "./hooks/use-embed-page";
export { useEmbedDrawer } from "./hooks/use-embed-drawer";
export { useEmbedDrawerSelect } from "./hooks/use-embed-drawer-select";
export { HostPage } from "./components/HostPage";
export { EmbedIFrame } from "./components/EmbedIFrame";

export const serviceEmbed = ({ registerTargets }) => {
  registerTargets({
    ONE_EMBED_PAGE: "one/embed/page"
  });

  return [
    {
      target: "$INIT_SERVICE",
      handler: onInitService,
      priority: 1
    }
  ];
};
